import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

export default function PaymentReturn({ cancel }) {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState(cancel ? "cancel" : "checking");

  useEffect(() => {
    if (cancel) return;
    const sid = sp.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); setStatus("success"); return; }
        if (data.status === "expired" || tries > 8) { setStatus("error"); return; }
      } catch { if (tries > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [cancel, sp, refresh]);

  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      {status === "checking" && <p className="text-urban-teal/60">Vérification du paiement...</p>}
      {status === "success" && (<><CheckCircle2 size={64} className="text-fresh-mint mx-auto" /><h1 className="font-display font-extrabold text-2xl text-urban-teal mt-4">Abonnement activé !</h1><p className="text-urban-teal/60 mt-2">Votre foodtruck est désormais mis en avant.</p><Button onClick={() => nav("/dashboard")} className="rounded-full bg-street-gold text-white font-bold mt-6" data-testid="payment-dashboard-btn">Aller à mon espace</Button></>)}
      {(status === "cancel" || status === "error") && (<><XCircle size={64} className="text-coral-twist mx-auto" /><h1 className="font-display font-extrabold text-2xl text-urban-teal mt-4">{status === "cancel" ? "Paiement annulé" : "Paiement non confirmé"}</h1><Button onClick={() => nav("/tarifs")} className="rounded-full bg-urban-teal text-white font-bold mt-6">Retour aux tarifs</Button></>)}
    </div>
  );
}
